import PRM from "@/core/PermissionConstants";
import RouteConstants from "@/app/core/RouteConstants";

export default {
  path: RouteConstants.DOCTOR.path,
  name: RouteConstants.DOCTOR.name,
  component: () => import("@/app/views/crud/CrudSimpleView.vue"),
  meta: {
    service: () => import("@/app/services/DoctorService"),
    table: () => import("@/app/components/doctor/DoctorTable"),
    form: () => import("@/app/components/doctor/DoctorForm"),

    header: {
      icono: "mdi-account",
      texto: "Médicos ",
      textNew: "Médicos | Nuevo",
      textEdit: "Médicos | Editar",
      textView: "Médicos "
    },
    prm: PRM.MODULE_DOCTOR,
    prmAdd: PRM.ADD_DOCTOR,
    requireAuth: true,
    filterModality: false,
    filterDate: true,
    saveButton: "Guardar",
    addButtonText: "Nuevo"
  },
};